var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement-content",staticStyle:{"white-space":"pre-wrap","line-height":"1.8","height":"300px","overflow-y":"auto"},domProps:{"innerHTML":_vm._s(_vm.htmlContent)}})
}
var staticRenderFns = []

export { render, staticRenderFns }